import { CaseState } from 'app/area/case/types-store';
import { StoreData } from 'app/types-shared';
import { getCaseData } from 'app/infrastructure/ui/renderer/resolvers';
import { getCaseId } from 'app/infrastructure/store/query';

export const caseId = (caseState: CaseState, uiEngineProps: any) => {
  const caseData: StoreData = getCaseData(caseState, uiEngineProps);

  const caseIdValue = getCaseId(caseData);

  return {
    ...(caseIdValue && { caseId: caseIdValue })
  };
};
